<div class="wrapper" ngbTooltip="{{ 'Monitors' | translate }}">
  <a (click)="overlay.toggle($event);">
    <i class="fas fa-heart-rate" [ngStyle]="{color: site24MainStatusUp() ? 'green' : 'red'}"></i>
  </a>
</div>
<qm-overlay-panel #overlay [stickTo]="'left-bottom'" [appendTo]="'body'" [dismissable]="true">
  <div class="card" style="margin-top: 0.8em;">
    <ng-container *ngIf="tenantsMonitors?.monitorList">
      <div class="monitor-list">
        <div *ngFor="let monitor of tenantsMonitors.monitorList">
          <div
            class="d-flex flex-row monitor"
            ngbTooltip="{{monitor.last_polled_time}}"
            [ngStyle]="{color: monitor.status === 1 ? 'green' : 'red'}">
            <a *ngIf="site24MonitorLink(monitor) as link; else monitorLabel" [href]="link" target="_blank">
              <ng-container [ngTemplateOutlet]="monitorLabel"></ng-container>
              <i class="fas fa-external-link"></i>
            </a>
            <ng-template #monitorLabel>
              {{monitor.name}}: {{site24StatusAsString(monitor.status)}}
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</qm-overlay-panel>
